<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { Text, CardGrid, SelectCard } from '@Shelly/shelly-design-system';
	import { capFirstChar } from '../../../../../../../../../helpers/utilities';
	import { format } from 'svelte-i18n';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let actions = [];
	export let active_actions = []; // because it is only one action we can be sure that active_actions contains only one element

	const dispatch = createEventDispatcher();

	const mappedActionIcons = {
		0: 'fas fa-power-off text-success',
		1: 'fas fa-power-off text-danger',
	};

	let title = actions[0]?.title || 'Unknown element';

	let groupStatesList = [
		...actions[0]?.values.map((action, i) => {
			return {
				id: action,
				title: `turn_${action}_the_group`,
				icon: mappedActionIcons[i],
			};
		}),
	];

	$: active = active_actions[0]?.value || undefined;

	const onChangeDeviceAction = (new_val) => {
		active_actions[0] = { name: actions[0].id, value: new_val };
		dispatch('change_active', { new_active: [...active_actions] });
	};
</script>

<Text element="h2" class="mb-s">{capFirstChar($format(title))}</Text>

<CardGrid gridGap="s" lg={290} sm={270} noPaddingBottom>
	{#each groupStatesList as card}
		<div class="d-flex">
			<SelectCard
				cardBgColor={$showNewLayout ? 'color-1' : undefined}
				class="width-full"
				type="horizontal"
				variant="radio"
				title={$format(card.title)}
				icon={card.icon}
				selected={card.id === active}
				on:click={() => {
					onChangeDeviceAction(card.id);
				}}
			/>
		</div>
	{/each}
</CardGrid>
